import React from "react";
import { ShieldCheck } from "lucide-react";

/**
 * Compliance surfaces for Strategy Automation (FIRE brief §6, education-first).
 * The banner renders on EVERY screen state of the tab and the footer closes it.
 * Required copy — do not soften, and never add income/profit/return claims.
 *
 * ORDER IS DELIBERATE (ARC-38). Non-custodial is the differentiator, so the
 * headline states it and the risk clause closes the same paragraph. Nothing was
 * dropped in the reframe: high risk, leveraged instruments, no outcome promised,
 * educational software / not financial advice, the delegate's inability to
 * withdraw and one-click revocation are all still here, all in the body's own
 * colour. The risk sentence shares an element with the custody copy precisely so
 * it cannot drift smaller or dimmer than what it qualifies.
 */

export const RiskBanner = () => (
  <div className="sa-custody" data-testid="sa-risk-banner">
    <ShieldCheck size={20} className="sa-custody-ico" aria-hidden="true" />
    <div>
      <p className="sa-custody-hd">Your keys. Your custody. Always.</p>
      <p className="sa-custody-txt">
        Unlike most platforms, ARC never holds your funds. The delegate can open
        and close trades — nothing else. It can never withdraw, and you can
        revoke it in one click, anytime. Automated trading of leveraged
        instruments is high risk and no outcome is promised — this is
        educational software, not financial advice.
      </p>
    </div>
  </div>
);

/**
 * The closing disclosure block, at the bottom of the tab where mockup v3 puts
 * it. The first paragraph is the mockup's footer copy verbatim; the second is
 * this tab's existing required disclosure, kept because dropping a compliance
 * surface is never a styling decision.
 */
/* Anything on the tab that offers to show the member the full disclosure —
   today the TradingView wizard's risk line (SUPERBETA-8) — scrolls to this. */
export const DISCLOSURE_DOM_ID = "sa-disclosure-footer";

export const DisclosureFooter = () => (
  <footer className="sa-footer" id={DISCLOSURE_DOM_ID} data-testid="sa-disclosure-footer">
    <p>
      Educational platform. Automation executes strategies you select; you retain
      custody of your funds at all times and may revoke delegate access at any
      moment. Automated trading of leveraged instruments carries substantial
      risk, including total loss — leverage raises liquidation risk. Values shown
      are live and will move. Past performance does not indicate future results.
      Nothing here is financial, investment, or tax advice.
    </p>
    <p>
      This is general educational software, not personalized financial advice.
      Trading leveraged derivatives carries a high risk of loss. You retain
      custody of your funds and can revoke the delegate at any time. No return
      or income is promised or implied.
    </p>
    <p className="font-mono uppercase tracking-[0.14em] text-[10px]">
      Non-custodial · Your keys stay with you · Revoke anytime
    </p>
  </footer>
);
